export default __webpack_public_path__ + "static/2-bc890244c27f72b363bd7b74d97655bb.png";